export enum Speaker {
    Agent_1 = "Agent",
    Customer_1 = "Customer",
    Agent_2 = "Agent 2",
    Customer_2 = "Customer 2",
    Agent_3 = "Agent 3",
    Customer_3 = "Customer 3",
    IVR = "IVR",
}
